import dayjs from 'dayjs';

export const FORM_SEARCH = () => {
  const span = 12;
  return [
    {
      label: 'ค้นหาผ่านวันที่',
      name: 'startDate',
      type: 'DATE_RANGE',
      span,
    },
  ];
};

export const searchDefaultValues = {
  search: '',
  startDate: [dayjs().startOf('month'), dayjs()],
};
